export default __webpack_public_path__ + "static/media/image-13.be5c8332.png";